import { ThemeColors } from '@contrast-security-inc/design-system-foundations'
import { theme } from '../../styled'
import { ThemeFontFamilies } from '../../styled/theme'

import { convertStyleConfigToClassname } from './builder'

export interface ClassNameConfig {
  fontFamily: keyof ThemeFontFamilies
  fontSize: string
  fontWeight?: number | string
  color?: ThemeColors
  textTransform?: 'uppercase' | 'lowercase'
  lineHeight?: string
  letterSpacing?: string
}

export const classNameConfigs: { [key: string]: ClassNameConfig } = {
  Body: {
    fontFamily: 'secondary',
    fontSize: '14px',
    fontWeight: 400,
    color: 'neutral100'
  },
  Badge: {
    fontFamily: 'primaryCondensed',
    fontSize: '12px',
    textTransform: 'uppercase'
  },
  Code: {
    fontFamily: 'code',
    fontSize: '14px',
    fontWeight: 400,
    color: 'neutral100'
  },
  DrilldownHeader: {
    fontFamily: 'primary',
    fontSize: '17px',
    fontWeight: 700,
    color: 'neutral100'
  },
  DrilldownPageTitle: {
    fontFamily: 'primary',
    fontSize: '21px',
    fontWeight: 500,
    color: 'neutral100'
  },
  FormLabel: {
    fontFamily: 'secondary',
    fontSize: '14px',
    fontWeight: 700,
    color: 'neutral60'
  },
  FormSectionTitle: {
    fontFamily: 'primary',
    fontSize: '17px',
    fontWeight: 700,
    color: 'neutral100'
  },
  LargeStats: {
    fontFamily: 'secondary',
    fontSize: '50px',
    fontWeight: '700',
    color: 'neutral60',
    lineHeight: '1'
  },
  MainSectionHeader: {
    fontFamily: 'primaryCondensed',
    fontSize: '20px',
    fontWeight: 400,
    textTransform: 'uppercase',
    letterSpacing: '0.01em',
    color: 'neutral50'
  },
  Metadata: {
    fontFamily: 'secondary',
    fontSize: '12px',
    fontWeight: 400,
    color: 'neutral60'
  },
  MetadataEditable: {
    fontFamily: 'secondary',
    fontSize: '12px',
    fontWeight: 400,
    color: 'neutral100'
  },
  NameTag: {
    fontFamily: 'handwriting',
    fontSize: '24px',
    fontWeight: 400,
    color: 'neutral100'
  },
  NullValue: {
    fontFamily: 'secondary',
    fontSize: '14px',
    fontWeight: 400,
    color: 'neutral50'
  },
  PageTitle: {
    fontFamily: 'primaryCondensed',
    fontSize: '32px',
    fontWeight: 700,
    color: 'neutral100'
  },
  PanelTitle: {
    fontFamily: 'primaryCondensed',
    fontSize: '13px',
    fontWeight: 400,
    textTransform: 'uppercase',
    color: 'neutral50'
  },
  ParagraphHeader: {
    fontFamily: 'primaryCondensed',
    fontSize: '16px',
    fontWeight: 700,
    color: 'neutral100'
  },
  ParagraphText: {
    fontFamily: 'secondary',
    fontSize: '13px',
    color: 'neutral80'
  },
  ReadOnlyGrid: {
    fontFamily: 'secondary',
    fontSize: '14px',
    fontWeight: 400,
    color: 'neutral60'
  },
  SmallStats: {
    fontFamily: 'secondary',
    fontSize: '34px',
    fontWeight: theme.fontWeights.secondary.bold,
    color: 'neutral50',
    lineHeight: '1'
  },
  TooltipBody: {
    fontFamily: 'secondary',
    fontSize: '13px',
    color: 'white'
  },
  WizardHeader: {
    fontFamily: 'primary',
    fontSize: '26px;',
    fontWeight: '700',
    color: 'neutral100'
  }
}

export const classNames: any = Object.keys(classNameConfigs).reduce(
  (prev, curr) => ({
    ...prev,
    [curr]: convertStyleConfigToClassname(classNameConfigs[curr])
  }),
  {}
)

export const bodyCss = convertStyleConfigToClassname(classNameConfigs.Body)
export const badgeCss = convertStyleConfigToClassname(classNameConfigs.Badge)
export const codeCss = convertStyleConfigToClassname(classNameConfigs.Code)
export const drilldownHeaderCss = convertStyleConfigToClassname(
  classNameConfigs.DrilldownHeader
)
export const drilldownPageTitleCss = convertStyleConfigToClassname(
  classNameConfigs.DrilldownPageTitle
)
export const formLabelCss = convertStyleConfigToClassname(
  classNameConfigs.FormLabel
)
export const formSectionTitleCss = convertStyleConfigToClassname(
  classNameConfigs.FormSectionTitle
)
export const largeStatsCss = convertStyleConfigToClassname(
  classNameConfigs.LargeStats
)
export const mainSectionHeaderCss = convertStyleConfigToClassname(
  classNameConfigs.MainSectionHeader
)
export const metadataCss = convertStyleConfigToClassname(
  classNameConfigs.Metadata
)
export const metadataEditableCss = convertStyleConfigToClassname(
  classNameConfigs.MetadataEditable
)
export const nameTagCss = convertStyleConfigToClassname(
  classNameConfigs.NameTag
)
export const nullValueCss = convertStyleConfigToClassname(
  classNameConfigs.NullValue
)
export const pageTitleCss = convertStyleConfigToClassname(
  classNameConfigs.PageTitle
)
export const panelTitleCss = convertStyleConfigToClassname(
  classNameConfigs.PanelTitle
)
export const paragraphHeaderCss = convertStyleConfigToClassname(
  classNameConfigs.ParagraphHeader
)
export const paragraphTextCss = convertStyleConfigToClassname(
  classNameConfigs.ParagraphText
)
export const readOnlyGridCss = convertStyleConfigToClassname(
  classNameConfigs.ReadOnlyGrid
)
export const smallStatsCss = convertStyleConfigToClassname(
  classNameConfigs.SmallStats
)
export const tooltipBodyCss = convertStyleConfigToClassname(
  classNameConfigs.TooltipBody
)
export const wizardHeaderCss = convertStyleConfigToClassname(
  classNameConfigs.WizardHeader
)
